import { render } from "./SiteStatsRelations.vue?vue&type=template&id=4204940e&scoped=true"
import script from "./SiteStatsRelations.vue?vue&type=script&lang=js"
export * from "./SiteStatsRelations.vue?vue&type=script&lang=js"

import "./SiteStatsRelations.vue?vue&type=style&index=0&id=4204940e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4204940e"]])

export default __exports__